<template>
  <v-layout >
  <v-flex class="pl-4 mb-3 cookie">
    <p>{{$tf('cookie_notice.intro')}}</p>
    <p>{{$tf('cookie_notice.description')}}</p>
    <a href="#"
       v-if="!moreInfo"
       @click.prevent="moreInfo = true">
      {{$tf('More Info')}}
    </a>
    <ul v-if="moreInfo">
      <p>{{$tf('cookie_notice.own_description')}}</p>
      <li>{{$tf('cookie_notice.own.0')}}</li>
    </ul>
    <br/>
    <ul v-if="moreInfo">
      <p>{{$tf('cookie_notice.third_description')}}</p>
      <li class="pb-1">{{$tf('cookie_notice.third.0')}}</li>
      <li class="pb-1">{{$tf('cookie_notice.third.1')}}</li>
    </ul>
    </v-flex>
  </v-layout>
</template>

<script>
  // @TODO: moving this to a provisionable .html

  export default {
    name: 'cookie-notice',
    computed: {
      isValid () {
        return this.$store.state.dialog.valid
      }
    },
    watch: {
      isValid: {
        immediate: true,
        handler () {
          this.$store.dispatch('dialog/setValid', true)
        }
      }
    },
    data () {
      return {
        moreInfo: false
      }
    }
  }
</script>

<style scoped>
  .cookie {
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/dialog/types/DialogCookieNotice.vue